import { HTMLAttributes } from 'react';
import 'twin.macro';
import 'styled-components/macro';

import { ReactComponent as ClockIcon } from './images/clock.svg';

export const ChallengeTimerText = ({ children, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div tw="flex items-center gap-half bg-white bg-opacity-20 px-1 rounded-full" {...props}>
    <ClockIcon tw="w-2" />
    <span tw="text-base">{children}</span>
  </div>
);
